export const environment = {
    production: false,
    olaApiKey: 'mkEE3HEQb6aQxQcJDtM1371NR5qtRcJoHds9vANS',
  // url: 'https://survey-api.databusted.com/app/api/v1/',
  url: 'https://qa-survey-api.vegease.in/panel/api/v1/',


}